module.exports = __webpack_public_path__ + "img/plan3.20c14528.svg";